export const menuItems = [
    {
        id: 'quickFilingRequest',
        label: 'QUICK FILING REQUEST',
        value: '/quick-filing-request',
        roles: ['Administrator', 'User'],
        iconClass: 'welcome m glyphicon glyphicon-forward'
    },
    {
        id: 'newFilingRequest',
        label: 'NEW FILING REQUEST',
        value: '/new-filing-request',
        roles: ['Administrator', 'User'],
        iconClass: 'welcome m glyphicon glyphicon-folder-open'
    },
    {
        id: 'pendingFilings',
        label: 'PENDING FILINGS',
        value: '/pending-filings',
        roles: ['Administrator', 'User'],
        iconClass: 'welcome m glyphicon glyphicon-list'
    },
    {
        id: 'onboarding',
        label: 'ONBOARDING',
        value: '/new-request',
        roles: ['Administrator', 'User'],
        iconClass: 'welcome m glyphicon glyphicon-save'
    },
    {
        id: 'pendingOnboarding',
        label: 'PENDING ONBOARDING',
        value: '/pending-securities',
        roles: ['Administrator', 'User'],
        iconClass: 'welcome m glyphicon glyphicon-edit'
    },
    {
        id: 'findSecurities',
        label: 'FIND FUNDS',
        value: '/client-details',
        roles: ['Administrator', 'User'],
        iconClass: 'welcome m glyphicon glyphicon-search'
    },
    {
        id: 'filings',
        label: 'FILINGS',
        value: '/filings',
        roles: ['Administrator'],
        iconClass: 'welcome m glyphicon glyphicon-duplicate'
    },
    {
        id: 'manageClients',
        label: 'MANAGE CLIENTS',
        value: '/client-information',
        roles: ['Administrator'],
        iconClass: 'welcome m glyphicon glyphicon-briefcase'
    },
    {
        id: 'manageStates',
        label: 'MANAGE STATES',
        value: '/manage-states',
        roles: ['Administrator'],
        iconClass: 'welcome m glyphicon glyphicon-globe'
    },
    {
        id: 'manageUsers',
        label: 'MANAGE USERS',
        value: '/sign-up',
        roles: ['Administrator'],
        iconClass: 'welcome m glyphicon glyphicon-user'
    }
];



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/services/employeePanel.menuItems.js